// src/hooks/useSticky.js
import { useEffect, useState } from "react";

export default function useSticky(elementId = "sticy_fixedss", offset = 130) {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const donatebutton = document.getElementById(elementId);
    const stickyPoint = donatebutton?.offsetTop || offset;

    const handleScroll = () => {
      setIsSticky(window.pageYOffset > stickyPoint);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [elementId, offset]);

  return isSticky;
}
